import $ from 'jquery'
import { Infer, instance, optional, type } from 'superstruct'
import Swiper, { Navigation, Autoplay } from 'swiper'

import { filterSections } from '../core/jquery/filter-sections'

const NAMESPACE = '.slideshow' as const

const HTMLElementWithSwiper = type({
  swiper: optional(instance(Swiper))
})

export type HTMLElementWithSwiper = Infer<typeof HTMLElementWithSwiper>

/**
 * Init homepage slideshow
 */
export const init = async function () {
  const unload = function (shopifyEvent?: unknown): void {
    const sections = $('.js-slideshow').filter(filterSections(shopifyEvent))
    sections.each(function (_, sElement) {
      const section = $(sElement)

      /* Unbind listeners */
      section.off(NAMESPACE)

      const { swiper } = HTMLElementWithSwiper.create(sElement)

      if (swiper) {
        swiper.destroy()
      }
    })
  }

  const load = function (shopifyEvent?: unknown): void {
    const sections = $('.js-slideshow').filter(filterSections(shopifyEvent))

    sections.each(function (_, sElement) {
      const section = $(sElement)

      /* Stretch each SVG placeholder image to fill slide */
      section.find('.js-slideshow-svg-image').each(function (__, svgElement) {
        svgElement.setAttribute('preserveAspectRatio', 'xMidYMid slice')
      })

      const slideshowContainer = section.find('.swiper-container').first()
      const slideCount = parseInt(
        slideshowContainer.attr('data-item-count') || '0',
        10
      )

      const slideDelay = parseInt(
        slideshowContainer.attr('data-delay') || '0'
      )
      const slideDelayAttr = (slideDelay ? { delay: slideDelay } : false);

      const slideshowContainerElement = slideshowContainer.get(0)

      if (!slideshowContainerElement || slideCount < 1) {
        return
      }

      const swiper = new Swiper(slideshowContainerElement, {
        autoHeight: true,
        direction: 'horizontal',
        init: false,
        loop: true,
        autoplay: slideDelayAttr,
        modules: [Navigation, Autoplay]
      })

      /* Activate arrows */
      section.on('click' + NAMESPACE, '.js-slideshow-arrow', function (evt) {
        const action = $(evt.currentTarget).attr('data-action')

        const swiperAction: 'slideNext' | 'slidePrev' =
          action === 'prev' ? 'slidePrev' : 'slideNext'

        swiper[swiperAction]()
      })

      /* Activate dots */
      section.on('change' + NAMESPACE, '.js-slideshow-dot', function (evt) {
        const nextSlideIndex: number = parseInt(
          $(evt.currentTarget).attr('data-slide-index') || '0',
          10
        )

        if (Number.isNaN(nextSlideIndex)) {
          return
        }

        swiper.slideToLoop(nextSlideIndex)
      })

      swiper.on('realIndexChange', function highlightPaginationDot(sw) {
        section
          .find(`.js-slideshow-dot[data-slide-index="${sw.realIndex}"]`)
          .prop('checked', true)
      })

      swiper.init()
    })
  }

  $(document).on('shopify:section:unload', unload)
  $(document).on('shopify:section:load', load)

  load()
}
